import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST = createAsyncActionType('GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST');

export const GET_WATCH_LIST_ENTRY_BY_WATCH_LIST = createAsyncActionType('GET_WATCH_LIST_ENTRY_BY_WATCH_LIST');

export const GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT = createAsyncActionType('GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT');

export const CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST = 'CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST';

export const SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS = 'SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS';

export const EXPORT_WATCH_LIST_ENTRIES_CSV = createAsyncActionType('EXPORT_WATCH_LIST_ENTRIES_CSV');

export const WATCH_LIST_DEACTIVATION = createAsyncActionType('WATCH_LIST_DEACTIVATION');

export const EXPORT_WATCH_LIST_ALL_ENTRIES_CSV = createAsyncActionType('EXPORT_WATCH_LIST_ALL_ENTRIES_CSV');

export const CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV = 'CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV';

export const CLEAR_EXPORT_WATCH_LIST_ALL_ENTRIES_CSV = 'CLEAR_EXPORT_WATCH_LIST_ALL_ENTRIES_CSV';

export const SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE = "SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE";

export const SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE = "SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE";



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/types/watchListEntryByWatchListTypes.js